/** QuickPlan — Bouton « Exporter en glTF (.glb) » : assemblage visible, en mètres,
 *  Y vers le haut, posé au sol et centré (cf. src/export/gltf.js). */
import { useState } from 'react';
import { useProjectStore } from '../store/useProjectStore.js';
import { downloadGlb, glbFileName } from '../export/gltf.js';

export default function ExportGlbButton({ className = '', label = '⤓ Exporter en glTF (.glb)' }) {
  const project = useProjectStore((s) => s.project);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const st = useProjectStore.getState();
    setBusy(true);
    try {
      await downloadGlb(st.project, st.lookup());
      st.setStatus(`Exporté : ${glbFileName(st.project)}`);
    } catch (e) {
      st.setStatus(`⚠ Export glTF impossible : ${e.message}`);
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      className={className}
      disabled={busy || !project?.instances.length}
      onClick={run}
      title="Modèle 3D de l'assemblage visible (pièces masquées exclues) — mètres, Y vers le haut, posé au sol et centré : pour QuickVision ou tout logiciel 3D"
    >
      {busy ? '…' : label}
    </button>
  );
}
